import * as React from 'react';
import { IconButton } from '@cian/frontend-reviews-components';
import { IconSocialLikeOn16, IconSocialDislikeOn16 } from '@cian/ui-kit-design-tokens/icons';
import { useDispatch, useSelector } from 'react-redux';
import { requestAuthentication } from '../../actions/authentication';
import { ILike } from '../../types/developerV2/review';
import { getIsAuthenticated } from '../../selectors';
import { ReviewsReactions } from '../../components/ReviewCommon/ReviewsReactions';
import { setReviewReaction } from '../../actions/reviews/setReviewReaction';

export interface IReviewsReactionsContainerProps {
  reviewId: string;
  reactions: ILike;
}

export const ReviewsReactionsContainer: React.FC<IReviewsReactionsContainerProps> = ({ reviewId, reactions }) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(getIsAuthenticated);

  const setAnswerLike = () => setReviewReaction({ reviewId, type: 'liked' });
  const setAnswerDislike = () => setReviewReaction({ reviewId, type: 'disliked' });

  const onLikeClick = React.useCallback(() => {
    if (isAuthenticated) {
      // @ts-expect-error
      dispatch(setAnswerLike());
    } else {
      // @ts-expect-error
      dispatch(requestAuthentication({ onSuccess: setAnswerLike }));
    }
  }, [dispatch, isAuthenticated, setAnswerLike, requestAuthentication]);

  const onDislikedClick = React.useCallback(() => {
    if (isAuthenticated) {
      // @ts-expect-error
      dispatch(setAnswerDislike());
    } else {
      // @ts-expect-error
      dispatch(requestAuthentication({ onSuccess: setAnswerDislike }));
    }
  }, [dispatch, isAuthenticated, setAnswerLike, requestAuthentication]);

  return (
    <ReviewsReactions
      like={
        <IconButton
          Icon={IconSocialLikeOn16}
          active={reactions.status === 'liked'}
          onClick={onLikeClick}
          label={reactions.likesCount}
        />
      }
      dislike={
        <IconButton
          Icon={IconSocialDislikeOn16}
          active={reactions.status === 'disliked'}
          onClick={onDislikedClick}
          label={reactions.dislikesCount}
        />
      }
    />
  );
};
